import { useState, useEffect, useCallback, Fragment } from 'react';
import { useVariant } from '../context/VariantContext';

export default function Hero() {
  const { hero } = useVariant();
  const [current, setCurrent] = useState(0);

  const next = useCallback(() => {
    setCurrent(prev => (prev + 1) % hero.images.length);
  }, [hero.images.length]);

  useEffect(() => {
    const id = setInterval(next, 5000);
    return () => clearInterval(id);
  }, [next]);

  return (
    <section className="lp__hero">
      <p className="lp__hero-subtitle">
        {hero.subtitle.map((line, i) => (
          <span key={i}>{i > 0 && <br />}{line}</span>
        ))}
      </p>
      <img
        className="lp__hero-brand"
        src={hero.logoSvg}
        alt={hero.logoAlt}
        width="200"
        height="80"
      />

      <div className="lp__hero-visual">
        <div className="lp__hero-image-frame">
          {hero.images.map((src, i) => (
            <img
              key={src}
              className={`lp__hero-slide${i === current ? ' lp__hero-slide--active' : ''}`}
              src={src}
              alt={hero.slideAlt}
              width="490"
              height="490"
              loading={i === 0 ? 'eager' : 'lazy'}
              fetchPriority={i === 0 ? 'high' : undefined}
            />
          ))}
        </div>
      </div>

      <div className="lp__hero-features">
        {hero.badges.map((badge, i) => (
          <Fragment key={i}>
            {i > 0 && <span className="lp__hero-x">×</span>}
            <div className="lp__hero-circle">
              <span className="lp__hero-circle__label">{badge.label}</span>
              <span className="lp__hero-circle__sub">{badge.sub}</span>
            </div>
          </Fragment>
        ))}
      </div>

      <h1 className="lp__hero-catchcopy">
        {hero.catchcopy.map((line, i) => (
          <span key={i}>{i > 0 && <br />}{line}</span>
        ))}
      </h1>
      <p className="lp__image-note">※写真はイメージです</p>
    </section>
  );
}
